import { DispositionRecommendedAction } from '@app/advisor-shared';
export const DispoTypeToHeader = {
    [DispositionRecommendedAction.ADMIT]: 'Admission',
    [DispositionRecommendedAction.DISCHARGE]: 'Discharge',
    [DispositionRecommendedAction.ENGAGED_ENCOUNTER]: 'Close Session'
};
//# sourceMappingURL=consts.js.map